<template>
  <div :key="periodsNumber+'ball'" class="lottery-gruop clearfix">
    <div v-if="types=='home'">
      <template v-if="lotteryCode=='CQSSC'">
        <cqssc :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass"></cqssc>
      </template>
      <template v-if="lotteryCode!='CQSSC'&&(bigClass == 'SSC' || bigClass == '11X5' || bigClass == 'LHC')">
        <ssc :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" :lottery="lottery" />
      </template>
      <template v-if="bigClass == 'K3'">
        <k3 :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" />
      </template>
      <template v-if="bigClass == 'PK10'">
        <pk10 :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" />
      </template>
      <template v-if="bigClass == 'PCDD'">
        <pcdd :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" />
      </template>
      <template v-if="bigClass == '3D'||bigClass == 'PL3'">
        <threeD :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" :lottery="lottery"/>
      </template>
      <template v-if="bigClass == 'SSQ'">
        <ssq :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" />
      </template>
      <template v-if="bigClass == 'DLT'">
        <dlt :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" />
      </template>
    </div>
    <div v-else-if="types=='lottery'">
      <template v-if="lotteryCode=='CQSSC'">
        <cqssc :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="lotteryTypeCode"></cqssc>
      </template>
      <template v-if="lotteryCode!='CQSSC'&&(lotteryTypeCode == 'SSC' || lotteryTypeCode == '11X5' || lotteryTypeCode == 'LHC')">
        <ssc :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="lotteryTypeCode" :lottery="lottery"/>
      </template>
      <template v-if="lotteryTypeCode == 'K3'">
        <k3 :drawingNumber="LotteryLatelyLpVo" :types="types" />
      </template>
      <template v-if="lotteryTypeCode == 'PK10'">
        <pk10 :drawingNumber="LotteryLatelyLpVo" :types="types" />
      </template>
      <template v-if="lotteryTypeCode == 'PCDD'">
        <pcdd :drawingNumber="LotteryLatelyLpVo" :types="types" />
      </template>
      <template v-if="lotteryTypeCode == '3D'||lotteryTypeCode == 'PL3'">
        <threeD :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" />
      </template>
      <template v-if="lotteryTypeCode == 'SSQ'">
        <ssq :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" />
      </template>
      <template v-if="bigClass == 'DLT'">
        <dlt :drawingNumber="LotteryLatelyLpVo" :types="types" :bigClass="bigClass" />
      </template>
    </div>
    
  </div>
</template>

<script>
import k3 from "./k3";
import ssc from "./ssc";
import pk10 from "./pk10";
import pcdd from "./pcdd";
import cqssc from "./cqssc";
import threeD from "./3D";
import ssq from "./ssq";
import dlt from "./dlt";
import zhishu from "./zhishu";
export default {
  name: "lottery-number",

  components: {
    ssc,
    k3,
    pk10,
    pcdd,
    cqssc,
    threeD,
    ssq,
    dlt,
    zhishu
  },
  data() {
    return {};
  },
  props: {
    lottery: {
      type: [Object],
      default: null
    },
    lotteryCode: {
      type: [String],
      default: null
    },
    types: {
      type: [String],
      default: null
    },
    bigClass: {
      type: [String],
      default: null,
    }
  },
  computed: {
    // playwayConfig() {
    //   return this.$store.state.lottery.playwayConfig;
    // },
    lotteryTypeCode() {
      return this.$store.state.lottery.lotteryTypeCode;
    },
    // lotteryCode() {
    //   return this.$store.state.lottery.lotteryCode;
    // },
    periodsNumber() {
      return this.$store.state.lottery.periodsNumber;
    },
    LotteryLatelyLpVo() {
      if (this.lottery) {
        return this.lottery.drawingNumber
          ? this.lottery.drawingNumber.split(",")
          : [];
      } else {
        return [];
      }
    }
  },
  methods: {},
  created() {}
};
</script>